var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[(_vm.isActive)?_c('div',{staticClass:"tab-container",attrs:{"role":"tabpanel","id":_vm.id + '-tab',"aria-describedby":_vm.id,"tabindex":"0"}},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }